<aside id="sidebar"
    class="z-10 pb-4 fixed lg:static top-0 left-0 z-40 bg-white shadow-lg
         transition-all duration-300 ease-in-out flex flex-col h-full"

  [ngClass]="[
    layout.isCollapsed() ? 'lg:w-24' : 'lg:w-72',
    layout.isMobileOpen() ? 'translate-x-0' : '-translate-x-full',
    'lg:translate-x-0'
  ]">    

  <!-- Button Toogle Desktop -->
  <div class="w-full max-w-9/10 relative">
    <button (click)="layout.toggleSidebar()" class="btn-close-nav py-2 px-3 rounded-full border-[6px] border-gray-100 bg-gray-200 hover:bg-gray-300 absolute -right-[22px] top-[62px]">
      <i class="text-gray-500 text-sm" [ngClass]="layout.isCollapsed() ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"></i>
    </button>
  </div>

  <!-- Logo -->
  <div class="flex items-center justify-center border-b px-6 py-8 transition-all duration-300">

    @if (!layout.isCollapsed()) {
      <img
        src="assets/Logo_Original.png"
        alt="Logo CySM"
        class="w-[150px] transition-all duration-300"
        />
    }

    @if (layout.isCollapsed()) {
      <img
        src="assets/Logo_favicon.png"
        alt="Logo Icon"
        class="w-[40px] transition-all duration-300"
        />
    }

  </div>

  <!-- Nav -->
  <nav class="flex-1 px-4 py-6 space-y-2">

    <!-- Item -->
    <a routerLink="/home" routerLinkActive="gardien-1 !text-amber-400" [routerLinkActiveOptions]="{exact: true}"
        class="flex items-center px-4 py-3 rounded-full transition text-sm text-gray-500 hover:bg-gray-100"
        [ngClass]="layout.isCollapsed() ? 'justify-center' : 'gap-3'"
      >
      <i class="pi pi-th-large"></i>

      <span
        class="transition-all duration-300 whitespace-nowrap"
          [ngClass]="layout.isCollapsed()  
            ? 'opacity-0 w-0 overflow-hidden'
            : 'opacity-100 w-auto ml-3'"
        >
        {{ 'common.sidebar.menu.dashboard' | transloco }}
      </span>
    </a>

    <!-- Analysis -->
    <a routerLink="/analysis/overview"
        class="flex items-center px-4 py-3 rounded-full transition text-sm text-gray-500 hover:bg-gray-100"
        [ngClass]="[
          layout.isCollapsed() ? 'justify-center' : 'justify-between',
          isModuleActive('/analysis') ? 'gardien-1 !text-amber-400' : ''
        ]">
      <div class="flex items-center" [ngClass]="layout.isCollapsed() ? '' : 'gap-3'">
        <i class="pi pi-database text-lg"></i>
        <span class="transition-all duration-300 whitespace-nowrap" [ngClass]="layout.isCollapsed()
              ? 'opacity-0 w-0 overflow-hidden'
              : 'opacity-100 w-auto'">
          {{ 'common.sidebar.menu.analysis' | transloco }}
        </span>
      </div>
      @if (!layout.isCollapsed()) {
        <button
          (click)="$event.stopPropagation(); $event.preventDefault(); toggleAnalysis()"
          class="p-1 rounded-full hover:bg-gray-200 transition-all duration-300">
          <i class="pi text-xs transition-all duration-300"
             [ngClass]="analysisExpanded() ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </button>
      }
    </a>

    @if (!layout.isCollapsed() && analysisExpanded()) {
      <!-- Sub-item: Listado -->
      <a routerLink="/analysis/overview" routerLinkActive="bg-amber-50 !text-amber-700" [routerLinkActiveOptions]="{exact: true}"
          class="flex items-center gap-3 py-2 pl-8 pr-4 rounded-full transition text-sm text-gray-500 hover:bg-gray-100">
        <i class="pi pi-list"></i>
        <span>Listado de análisis</span>
      </a>

      @if (permissionService.has(Permission.ANALYSIS_CREATE)) {
        <!-- Sub-item: Crear -->
        <a routerLink="/analysis/create" routerLinkActive="bg-amber-50 !text-amber-700" [routerLinkActiveOptions]="{exact: true}"
            class="flex items-center gap-3 py-2 pl-8 pr-4 rounded-full transition text-sm text-gray-500 hover:bg-gray-100">
          <i class="pi pi-file-arrow-up"></i>
          <span>Crear un nuevo análisis</span>
        </a>
      }

    }

    @if (permissionService.has(Permission.LOCATIONS_VIEW) || permissionService.has(Permission.ORGANIZATIONS_CREATE)) {
      <!-- Configuración -->
      <a routerLink="/configuration" routerLinkActive="gardien-1 !text-amber-400"
          class="flex items-center px-4 py-3 rounded-full transition text-sm text-gray-500 hover:bg-gray-100"
          [ngClass]="layout.isCollapsed() ? 'justify-center' : 'gap-3'"
        >
        <i class="pi pi-sitemap"></i>

        <span
          class="transition-all duration-300 whitespace-nowrap"
            [ngClass]="layout.isCollapsed()
              ? 'opacity-0 w-0 overflow-hidden'
              : 'opacity-100 w-auto ml-3'"
          >
          {{ 'common.sidebar.menu.configuration' | transloco }}
        </span>
      </a>
    }

  </nav>

  <!-- Bottom Buttons -->
  @if (permissionService.has(Permission.ANALYSIS_CREATE) || isOnAnalysisDetail()) {
    <div class="p-4 space-y-3 border-t bg-white">

      @if (permissionService.has(Permission.ANALYSIS_CREATE)) {
        <a routerLink="/analysis/create" routerLinkActive="opacity-90"
          class="w-full py-3 bg-amber-400 hover:bg-blue-950 text-blue-900 hover:text-white rounded-full transition-all duration-300 shadow-md text-sm flex items-center justify-center"
          >
          <i class="pi pi-file-plus text-lg"></i>
          <span class="transition-all duration-300 whitespace-nowrap"
              [ngClass]="layout.isCollapsed() ? 'opacity-0 w-0 overflow-hidden ml-0' : 'opacity-100 w-auto ml-2'">
            {{ 'common.sidebar.actions.createAnalysis' | transloco }}
          </span>
        </a>
      }

      @if (isOnAnalysisDetail()) {
        <button
          [disabled]="!downloadUrl()"
          (click)="downloadAnalysis()"
          class="w-full py-3 bg-gradient-to-r from-blue-950 to-blue-900 hover:opacity-90 text-white rounded-full transition-all duration-300 shadow-md text-sm flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
          >
          <i class="pi pi-download text-lg"></i>
          <span class="transition-all duration-300 whitespace-nowrap"
              [ngClass]="layout.isCollapsed() ? 'opacity-0 w-0 overflow-hidden ml-0' : 'opacity-100 w-auto ml-2'">
            {{ 'common.sidebar.actions.downloadAnalysis' | transloco }}
          </span>
        </button>
      }

    </div>
  }

  
</aside>